import React from "react";
import { FormattedMessage } from 'react-intl';

/**
 * @author
 * @function Price
 **/

const Price = (props) => {
  return (
    <div
      style={{
        fontSize: props.fontSize ? props.fontSize : "14px",
        fontWeight: "bold",
        margin: "5px 0",
      }}
    >
     
      {props.value}
      <FormattedMessage id='lak'/>
    </div>
  );
};

export default Price;
